<div class="modal-header border-0">
  <button *ngIf="hostService.rootPage" class="back-button" (click)="goBack()">
    <i class="gpicon-back-fat"></i>
  </button>

  <button
    class="btn-close"
    [gptDataTrack]="editMode ? 'analyses-edit-close' : 'analyses-add-close'"
    (click)="modal.dismiss()"
  >
    <i class="gpicon-close"></i>
  </button>
</div>

<div class="custom-scroll-parent gpx-8">
  <div
    class="modal-body custom-scroll gpx-16 gpx-sm-88 gpb-24 gpb-sm-48 gpt-48"
  >
    <h4
      class="h4-bold gmb-28 gmb-md-32"
      [innerHTML]="configuration?.shortName"
    ></h4>

    <app-measurement-add-host
      [configuration]="configuration"
      [analysisResult]="analysisResult"
      [detailedResult]="detailedResult"
      [backVisible]="false"
      [formFieldAppearance]="GpuFormFieldAppearance.Outline"
      [editMode]="editMode"
      (saved)="modal.close($event)"
      (closed)="modal.dismiss($event)"
    ></app-measurement-add-host>
  </div>
</div>
